// extracted by mini-css-extract-plugin
export default {"root":"root-_3WGH4","empty":"empty-BcwqCv"};